import {PlannerBaseModal} from '../../planner-base-modal';
import {useModalBtns} from '../../../../../../../../../components/modal/use-modal-btns';

export type PlannerCreateAnniversaryModalProps = {
  open: boolean;
  onClose: () => void;
};

export function PlannerCreateAnniversaryModal(props: PlannerCreateAnniversaryModalProps) {
  const actionBtns = useModalBtns({
    left: {
      type: 'cancel',
      onClick: props.onClose,
    },
  });

  return (
    <PlannerBaseModal open={props.open} onClose={props.onClose} title="TODO" actions={actionBtns}>
      {(() => {
        // ------------- STEP 1 -------------
        return <>TODO</>;
      })()}
    </PlannerBaseModal>
  );
}

// -------------------------------------------------------------------------
// -------------------------------------------------------------------------
// -------------------------------------------------------------------------
